// extracted by mini-css-extract-plugin
export var compactFilters = "_cq-4";
export var detailImage = "_cq-1";
export var dropdownContainer = "_cq-2";
export var imageContainer = "_cq-0";
export var selectedCard = "_cq-3";